const t = (o) => ({
  groupLabel: {
    color: o.palette.common.blue400,
    fontWeight: o.typography.fontWeightBold
  },
  divider: {
    borderColor: o.palette.common.blue100
  },
  formGroup: {
    width: "100%"
  },
  expandIcon: {
    color: o.palette.common.grey500
  },
  arrowAdornment: {
    position: "absolute",
    right: 12,
    height: "auto",
    zIndex: -1
  },
  defaultIcon: {
    display: "none"
  },
  formField: {
    width: "100%"
  },
  inputLabel: {
    display: "inline-flex",
    color: o.palette.common.grey500,
    marginBottom: 4
  },
  inputField: {
    border: `1px solid ${o.palette.common.grey100}`,
    backgroundColor: o.palette.common.white,
    borderRadius: 4,
    zIndex: o.zIndex.zIndex10,
    "& > input, & > textarea, & > .MuiSelect-select": {
      color: o.palette.text.primary,
      fontSize: o.typography.fontSize15,
      lineHeight: 1.2,
      fontWeight: o.typography.fontWeightSemiBold,
      paddingTop: 16,
      paddingBottom: 16,
      "&::placeholder": {
        color: o.palette.common.grey200,
        fontWeight: o.typography.fontWeightRegular
      }
    },
    "& > textarea": {
      padding: 0
    }
  },
  menuList: {
    padding: 24,
    minWidth: 100,
    maxWidth: "100%",
    maxHeight: 350,
    "@media(max-width: 600px)": {
      padding: 8
    }
  },
  menuItem: {
    color: o.palette.common.blue400,
    borderBottom: `1px solid ${o.palette.common.grey20}`,
    whiteSpace: "normal",
    "&:not(:last-child)": {
      marginBottom: 16
    },
    "@media(max-width: 600px)": {
      fontSize: o.typography.fontSize14,
      minHeight: "auto",
      "&:not(:last-child)": {
        marginBottom: 8
      }
    }
  },
  menuItemText: {
    color: o.palette.common.blue400
  }
}), e = t;
export {
  e as default
};
